module.exports = __webpack_public_path__ + "static/media/shdocvw_274.146aeb70.ico";